import { FieldsOptions } from '@sim/form';
import { dateValidator } from '@sim/form/validators';

import { Attachment, AttachmentMeta } from './attachament';

export interface Movement {
  allegati: Attachment[];
  dataRientro: string;
  dataUscita: string;
  descrizione: string;
  scopo: string;
}

export const MovementMeta: FieldsOptions<Movement> = {
  allegati: { type: 'array', controls: AttachmentMeta, value: [] },
  dataRientro: { validators: [dateValidator()] },
  dataUscita: { validators: [dateValidator()] },
  descrizione: {},
  scopo: {},
};
